import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ResetPassword from "@/pages/ResetPassword";
import { LinkitAuthProvider } from "@/linkit/AuthContext";
import MarketingHome from "@/linkit/pages/MarketingHome";
import FeaturesPage, { AnalyticsPage, ExamplesPage, PricingPage, AboutPage, TermsPage, PrivacyPage, RefundPage, ContactPage } from "@/linkit/pages/MarketingPages";
import Auth from "@/linkit/pages/Auth";
import VerifyEmail from "@/linkit/pages/VerifyEmail";
import Dashboard from "@/linkit/pages/Dashboard";
import PublicPage from "@/linkit/pages/PublicPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LinkitAuthProvider>
          <Routes>
            {/* Linkit SaaS marketing is the domain homepage. */}
            <Route path="/" element={<MarketingHome />} />
            {/* Aly's flagship credit-card site — now under /aly, and admin unchanged. */}
            <Route path="/aly" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />

            {/* Linkit SaaS — marketing site.  /create still works as an alias for
                the marketing home so existing shared links don't 404, and every
                sub-page keeps its /create/* URL to avoid churn on external links. */}
            <Route path="/create" element={<MarketingHome />} />
            <Route path="/create/features" element={<FeaturesPage />} />
            <Route path="/create/analytics" element={<AnalyticsPage />} />
            <Route path="/create/examples" element={<ExamplesPage />} />
            <Route path="/create/pricing" element={<PricingPage />} />
            <Route path="/create/about" element={<AboutPage />} />
            <Route path="/create/terms" element={<TermsPage />} />
            <Route path="/create/privacy" element={<PrivacyPage />} />
            <Route path="/create/refund-policy" element={<RefundPage />} />
            <Route path="/create/contact" element={<ContactPage />} />

            {/* Linkit SaaS — app */}
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/signup" element={<Auth mode="signup" />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/u/:username" element={<PublicPage />} />
          </Routes>
        </LinkitAuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
